import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide05Library = () => {
  const formats = [{
    num: '01',
    name: 'Reflection',
    desc: 'Synthesize readings and articulate key insights before class'
  }, {
    num: '02',
    name: 'Interactive Quiz',
    desc: 'Voice-probed questions that test reasoning, not just recall'
  }, {
    num: '03',
    name: 'Oral Defense',
    desc: 'Upload written work, then defend it under rigorous questioning'
  }, {
    num: '04',
    name: 'Critical Thinking',
    desc: 'Apply a framework to a new situation, discuss trade-offs'
  }, {
    num: '05',
    name: 'Case Discussion',
    desc: 'Analyze a business case, get challenged on recommendations'
  }, {
    num: '06',
    name: 'Keynote',
    desc: 'Present and defend a presentation against a rubric'
  }, {
    num: '07',
    name: 'Role Play',
    desc: 'Assume a role and navigate a realistic scenario',
    pipeline: true
  }, {
    num: '08',
    name: 'Debate',
    desc: 'Argue a position, handle counterarguments in real time',
    pipeline: true
  }, {
    num: '09',
    name: 'Teach-Back',
    desc: 'Explain a concept as if teaching a peer who has never seen it',
    pipeline: true
  }, {
    num: '10',
    name: 'Problem Solving',
    desc: 'Diagnose a complex, ambiguous situation with no single right answer',
    pipeline: true
  }];
  return <SlideContainer data-id="element-98">
      <FadeInStagger data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="mb-16" data-id="element-101">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-4" data-id="element-102">
              If you can imagine it, we can build it
            </h2>
            <h3 className="text-xl text-white/60 font-medium max-w-3xl leading-relaxed" data-id="element-103">
              10+ exercise formats, each plug-and-play. Built on your content,
              configurable to any course.
            </h3>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-104">
          {formats.map((format, i) => <FadeIn key={i} data-id="element-105">
              <div className="bg-card border border-white/5 p-6 rounded-xl flex items-start gap-4 h-full" data-id="element-106">
                <div className="text-accent-purple/50 font-mono text-sm mt-1" data-id="element-107">
                  {format.num}
                </div>
                <div data-id="element-108">
                  <div className="flex items-center gap-3 mb-2" data-id="element-109">
                    <h4 className="text-white font-medium" data-id="element-110">{format.name}</h4>
                    {format.pipeline && <span className="text-[10px] uppercase tracking-wider bg-accent-blue/10 text-accent-blue px-2 py-0.5 rounded-full" data-id="element-111">
                        In pipeline
                      </span>}
                  </div>
                  <p className="text-sm text-white/50 leading-relaxed" data-id="element-112">
                    {format.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </FadeInStagger>
    </SlideContainer>;
};